import PropTypes from 'prop-types';
import React from 'react';
import { JsonView } from './WildSky/JsonView';
import { Button } from 'react-bootstrap';

function getStateFromHash() {
    const text = window.location.hash;
    if (!text) {
        return {};
    }
    return JSON.parse(decodeURIComponent(text.substring(1)));
}

function setStateToHash(value) {
    window.location.hash = encodeURIComponent(JSON.stringify(value));
}

function formatError(error) {
    if (typeof error === 'object') {
        return <pre style={{ color: 'red' }}>{JSON.stringify(error, null, 4)}</pre>;
    } else {
        return <div style={{ color: 'red' }}>{error}</div>;
    }
}

class AggregateLogs extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            data: null,
            error: null,
            pipeline: getStateFromHash().pipeline || JSON.stringify([]),
        };
    }

    componentDidUpdate() {
        const data = getStateFromHash();
        data.pipeline = this.state.pipeline;
        setStateToHash(data);
    }

    componentDidMount() {
        this.startRequest();
    }

    onRefresh = () => {
        this.setState({ loading: true, error: null, data: null });
        this.startRequest();
    }

    async startRequest() {
        try {
            const response = await fetch(`${this.props.url}/${this.props.collection}`, {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    pipeline: eval(`(${this.state.pipeline})`),
                }),
            });
            const result = await response.json();
            if (result.error) {
                this.setState({ loading: false, error: result.error });
            } else {
                this.setState({ loading: false, data: result.results });
            }
        } catch (err) {
            this.setState({ loading: false, error: err.message });
        }
    }

    handleTextField = name => e => {
        this.setState({ [name]: e.target.value, error: null });
    }

    render() {
        let valid = true;
        let reason = '';
        if (this.state.error) {
            valid = false;
            reason = reason || this.state.error;
        }
        try {
            const query = eval(`(${this.state.pipeline})`);
            if (typeof query !== 'object') {
                valid = false;
                reason = reason || 'Expecting an object instead of ' + (typeof query) + ': ' + this.state.pipeline;
            }
        } catch (err) {
            valid = false;
            reason = reason || err.message;
        }
        window.data = this.state.data;
        // console.log(this.state.data);
        return (
            <div>
                {!valid && formatError(reason)}
                <div>
                    <Button onClick={this.onRefresh} disabled={!valid}>Refresh</Button>
                </div>
                <textarea rows={10} cols={100} value={this.state.pipeline} onChange={this.handleTextField('pipeline')} />
                {
                    this.state.loading && <div>Loading...</div>
                }
                {
                    !this.state.loading &&
                    <JsonView value={this.state.data} />
                }
            </div>
        );
    }
}

AggregateLogs.propTypes = {
    url: PropTypes.string,
    collection: PropTypes.string,
};

class CollectionList extends React.PureComponent {
    state = {
        results: null,
    };

    componentDidMount() {
        this.fetchCollectionList();
    }

    async fetchCollectionList() {
        const response = await fetch(this.props.url);
        const result = await response.json();
        this.setState({ results: result.results.sort() });
    }

    onClick = result => () => {
        this.props.onSelect(result);
    }

    render() {
        if (!this.state.results) {
            return "Loading...";
        }
        return (
            <ul>
                {
                    this.state.results.map(result => (
                        <li key={result} onClick={this.onClick(result)} style={{ backgroundColor: result === this.props.selected ? 'skyblue' : null }}>{result}</li>
                    ))
                }
            </ul>
        );
    }
}

CollectionList.propTypes = {
    selected: PropTypes.string,
    onSelect: PropTypes.func,
    url: PropTypes.string,
};

class Aggregate extends React.PureComponent {
    state = {
        collection: getStateFromHash().collection,
    };

    componentDidUpdate() {
        const data = getStateFromHash();
        data.collection = this.state.collection;
        setStateToHash(data);
    }

    onSelect = result => {
        this.setState({ collection: result });
    }
    render() {
        return (
            <div style={{ display: 'flex', height: '100%' }}>
                <div style={{ width: '200px', flexShrink: 0 }}>
                    <CollectionList url={this.props.collectionsUrl} selected={this.state.collection} onSelect={this.onSelect} />
                </div>
                <div style={{ flexGrow: 1, position: 'relative' }}>
                    <div style={{ position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, overflow: 'auto' }}>
                        {
                            this.state.collection &&
                            <AggregateLogs key={this.state.collection} url={this.props.aggregateUrl} collection={this.state.collection} />
                        }
                    </div>
                </div>
            </div>
        );
    }
}

Aggregate.propTypes = {
    collectionsUrl: PropTypes.string,
    aggregateUrl: PropTypes.string,
};

export function WildSkyAggregate() {
    return <Aggregate collectionsUrl="/api/data/collections" aggregateUrl="/api/data/aggregate" />;
}

export function SupportAggregate() {
    return <Aggregate collectionsUrl="/api/data/support_collections" aggregateUrl="/api/data/aggregate_support" />;
}
